import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { Page, Group, Layout, Button } from "@/comn/components";
import { useForm, useFetch, useGrid, useStore, usePopup, useToast, useModal, useResource } from "@/comn/hooks";
import { BASE, APIS, SF_HLDY_SRCH, SG_HLDY_LIST } from "./services/ComnCdService";
import { Link } from "react-router-dom";

export const HldyList = (props: any) => {
    const pgeUid = "hldyLst";
    const { t } = useTranslation();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();
    const modal = useModal();
    const params = props.params;

    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "OSC0098" }],
    });

    /*
     * 명명 규칙 (useForm)
     * prefix : "form_"
     * 카멜 표기법 사용, prefix 뒤에 대문자로 시작
     * 폼 사용 특성 : 검색(Srch), 등록,수정(Rgsr)
     * form_[폼 데이터 메타 조합 + 폼 사용 특성]
     * 예) 도시코드검색( form_hldySrch ) , 도시코드등록( form_CityCdRgsr )
     */
    const form = {
        hldySrch: useForm({
            defaultSchema: SF_HLDY_SRCH,
            // defaultValues: { ...pgeStore?.form, ...params } || {},
            // defaultValues: { ...params } || {},
        }),
    };

    /*
     * 명명 규칙 (useWijmo)
     * prefix : "grid_"
     * 카멜 표기법 사용, prefix 뒤에 대문자로 시작
     * grid_[그리드 데이터 명 메타 조합]
     * 예) 도시코드( grid_CityCd )
     */
    const grid = {
        hldyLst: useGrid({
            defaultSchema: SG_HLDY_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * 명명 규칙 (useFetch)
     * prefix : "fetch_"
     * 카멜 표기법 사용, prefix 뒤에 대문자로 시작
     * fetch_[백앤드 api 컨트롤러 메소드 명]
     * 예) 도시코드목록조회( fetch_getHldyLst )
     */
    const fetch = {
        getHldyLst: useFetch({
            /*
             * api : 해당 fetch 가 실제 실행하는 API, Service 에 정의 후 사용
             * enabled : 해당 fetch 가 실행가능한 조건
             * key : 변경되었을때 fetch 가 재실행되는 key
             * showToast : fetch 의 성공 실패 결과를 Toast 메세지로 표시 여부, default : false
             */
            api: (page = grid.hldyLst.page) => {
                return APIS.getHldyLst(form.hldySrch.getValues(), page, grid.hldyLst.size);
            },
            enabled: comnUtils.isEmpty(form.hldySrch.errors) && form.hldySrch.isSubmitted,
            key: [grid.hldyLst.page, grid.hldyLst.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.hldySrch.getValues(),
                    page: grid.hldyLst.page,
                    size: grid.hldyLst.size,
                });
            },
        }),
    };
    /*
     * 이벤트 핸들러
     */
    const handler = {
        /*
         * 이벤트 handler
         * [이벤트 타입]_[이벤트 대상 타입(대상명)]_[대상명]
         * 이벤트 타입 : click , change , blur , focus...
         * 이벤트 대상 타입 : Btn(버튼) , Grid
         * 이
         */
        click_Btn_Srch: () => {
            form.hldySrch.handleSubmit(
                () => {
                    grid.hldyLst.setPage(0);
                    fetch.getHldyLst.fetch(0);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },

        /* * */
        click_Btn_Apply: () => {
            const list: any[] = grid.hldyLst.getChecked() || [];
            if (comnUtils.isEmpty(list)) {
                modal.openModal({ content: "msg.osc.00084" });
                return;
            }

            props?.callback?.({ data: list });
            modal.closeModal(props.id);
        },
    };

    const render = {
        grid_hldyLst: {
            cell: {
                ctraDt: (arg: any) => {
                    const { binding, rowValues, value } = arg;
                    return (
                        <Link
                            to={"#"}
                            onClick={(e) => {
                                e.preventDefault();
                                props?.callback?.({ code: value, label: rowValues.hldyNm, rowValues: rowValues });
                                modal.closeModal(props.id);
                            }}
                        >
                            {arg.value}
                        </Link>
                    );
                },
            },
        },
    };

    useEffect(() => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        form.hldySrch.setValue("ctraYy", currentYear);

        handler.click_Btn_Srch();
        /* * */
        if (params?.multiple === true) {
            grid.hldyLst.setOption("checkbox", true);
        }
    }, []);

    return (
        <Page title={t("T_HLDY_LST")} info={true}>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.hldySrch.schema.ctraYy}></Group.Control>
                                <Group.Control {...form.hldySrch.schema.hldyTpCd}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    onClick={() => {
                                        form.hldySrch.reset();
                                    }}
                                >
                                    {t("B_RESET")}
                                </Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    onClick={() => {
                                        handler.click_Btn_Srch();
                                    }}
                                >
                                    {t("B_SRCH")}
                                </Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>

            <Group>
                <Group.Body>
                    {/* * */}
                    {params?.multiple === true && (
                        <Layout>
                            <Layout.Right>
                                <Button
                                    role="apply"
                                    onClick={() => {
                                        handler.click_Btn_Apply();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    )}
                    <Grid {...grid.hldyLst.grid} data={fetch.getHldyLst.data?.hldyList} render={render.grid_hldyLst} />
                </Group.Body>
            </Group>
        </Page>
    );
};
